import './Tooltip.css';
import { Tooltip as MuiTooltip, styled, tooltipClasses } from '@mui/material';

import MaterialInfoIcon from '../../core/MaterialIcons/MaterialInfoIcon';

const Tooltip = ({ text, style = {}, ...props }) => {
  {
    return (
      <StyledTooltip title={text ?? props.children} sx={{ width: 200, ...style }} {...props}>
        <span className="tooltip-icon">
          <MaterialInfoIcon />
        </span>
      </StyledTooltip>
    );
  }
};

export const StyledTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#222626',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#222626',
    fontSize: 14,
    whiteSpace: 'pre-line',
    boxShadow: '0px 8px 16px 0px #0000004d',
    borderRadius: 1,
    fontFamily: 'Calibre-R',
    fontWeight: 400,
  },
}));

export default Tooltip;
